<template>
  <div id="settingsPassword">
    
    <div class="name">Change Password</div>
    
    <div class="settings-content">

      <v-text-field
        label="Current Password"
        type="password"
        ref="inputCurrent"
        v-model="current"
        :rules="rules.current"
        :validate-on-blur="$refs.inputCurrent && $refs.inputCurrent.valid"
      ></v-text-field>

      <v-text-field
        label="New Password"
        type="password"
        ref="inputPass1"
        v-model="pass1"
        :rules="rules.pass1"
        :validate-on-blur="$refs.inputPass1 && $refs.inputPass1.valid"
      ></v-text-field>

      <v-text-field
        label="Confirm New Password"
        type="password"
        ref="inputPass2"
        v-model="pass2"
        :rules="rules.pass2"
        :validate-on-blur="$refs.inputPass2 && $refs.inputPass2.valid"
      ></v-text-field>

    </div>

    <div class="buttons">
      <v-btn class="button" :loading="lockout" color="primary"  flat @click="save()">Save</v-btn>
    </div>
    <div class="clear"></div>

  </div>

</template>

<script>

  export default {
    data () {
      return {
        current : '',
        pass1   : '',
        pass2   : '',
        lockout : false,
        passwordWrong: false,
        rules: {
          current: [
            function (e) {
              return !window.regex.password.test(e) ? 'Password must be at least 6 characters.' : true;
            },
            function (e) { 
              if (this.passwordWrong) {
                this.passwordWrong = false

                return 'Current password is incorrect';
              }

              return true;
            }.bind(this)
          ],
          pass1: [
            function (e) {
              return !window.regex.password.test(e) ? 'Password must be at least 6 characters.' : true;
            },
            function (e) {
              return this.current === this.pass1 ? 'New password must be different than existing password' : true;              
            }.bind(this)
          ],
          pass2: [
            function (e) {
              return this.pass1 !== this.pass2 ? 'Passwords must match.' : true;
            }.bind(this)
          ]
        }
      }
    },

    methods: {
      save () {
        this.lockout = true;
        var valid = this.validate();

        if (!valid) {
          Toast.show('Please correct the highlighted errors.', 'error');
          this.lockout = false;
          return;
        }

        this.$store.dispatch('saveProfile', {
          user: {
            currentPassword: this.current,
            password: this.pass1
          }
        })
        .then(data => {

          this.current = this.pass1 = this.pass2 = '';

          Toast.show('Password changed.', 'success');
          this.lockout = false;
        })
        .catch(e => {
          console.log(e);

          if (e.error && e.error.code && e.error.code === 40008) {
            this.passwordWrong = true;
            this.validate();
          }

          Toast.showError(e);
          this.lockout = false;
        });
      },

      validate () {
        this.$refs.inputCurrent.validate(true);
        this.$refs.inputPass1.validate(true);
        this.$refs.inputPass2.validate(true);

        return (this.$refs.inputCurrent.valid &&
                this.$refs.inputPass1.valid &&
                this.$refs.inputPass2.valid);
      }
    },

    created () {
      this.$nextTick( () => {
        this.$refs.inputCurrent.valid = true;
        this.$refs.inputPass1.valid = true;
        this.$refs.inputPass2.valid = true;
      });
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #settingsProfile {
    position: relative;  
  }

</style>



// WEBPACK FOOTER //
// src/components/SettingsPassword.vue